"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttributeType = void 0;
var AttributeType;
(function (AttributeType) {
  AttributeType["TEAMMEBER"] = "TEAMMEBER";
  AttributeType["NUMBER"] = "NUMBER";
  AttributeType["STRING"] = "STRING";
  AttributeType["EMAIL"] = "EMAIL";
  AttributeType["ENUM"] = "ENUM";
  AttributeType["ENUMARRAY"] = "ENUMARRAY";
  AttributeType["PHONE"] = "PHONE";
  AttributeType["DATE"] = "DATE";
  AttributeType["DATETIME"] = "DATETIME";
  AttributeType["LATLON"] = "LATLON";
})(AttributeType = exports.AttributeType || (exports.AttributeType = {}));